import { ComponentType, FC, useEffect } from 'react';
import { login as aadLogin, logout as aadLogout, getAccessToken as aadGetAccessToken } from 'TaxAnalyticsHelpers/AADHelper';
import { getUserProfile } from 'TaxAnalyticsHelpers/GraphHelper';
import { ApiClient } from 'TaxAnalyticsHelpers';
import { useRecoilState } from 'recoil';
import { userState } from 'TaxAnalyticsState/userState';
import { AuthenticatedUser } from 'TaxAnalyticsState/userState';
import { snackbarState } from 'TaxAnalyticsState/portalState';
import { useMsal } from '@azure/msal-react';

export type SetIntersection<A, B> = A extends B ? A : never;
export type SetDifference<A, B> = A extends B ? never : A;
export type SetComplement<A, A1 extends A> = SetDifference<A, A1>;
export type Subtract<T extends T1, T1 extends object> = Pick<
    T,
    SetComplement<keyof T, keyof T1>
>;

export interface AuthComponentProps {
    login: Function;
    logout: Function;
    getAccessToken: Function;
    setError: Function;
    user: AuthenticatedUser;
}

export const withAuthProvider = <T extends AuthComponentProps>(Component: ComponentType<T>, init: boolean): FC<Subtract<T, AuthComponentProps>> =>
    ({ ...props }) => {
        const [state, setState] = useRecoilState(userState);
        const [, setSnackbarState] = useRecoilState(snackbarState);
        const { accounts } = useMsal();
        const login = async (redirectPath: string) => {
            try {
                await aadLogin(redirectPath);
                await populateUserProfile();
                //debugger;
                setSnackbarState({
                    message: `Bienvenue !`,
                    open: true,
                    severity: 'success'
                })
            }
            catch (ex: any) {
                //debugger;
                setSnackbarState({
                    message: `Probleme de connexion`,
                    open: true,
                    severity: 'error',

                })
                console.log(ex);
            }
        };

        const logout = () => {
            ApiClient.authClient.logout()
                .catch(console.error)
                .then(() => aadLogout());
        };
        const getAccessToken = aadGetAccessToken;

        const populateUserProfile = async () => {
            setState({
                ...state,
                authenticating: true
            });
            try {
                const authState = await getUserProfile();
                if (authState.isAuthenticated) {
                    var userData = await ApiClient.authClient.get();
                    setState({
                        isAuthenticated: true,
                        initials: getInitials(authState.user?.givenName, authState.user?.surname),
                        displayName: authState.user?.givenName,
                        user: {
                            ...userData
                        },
                        authenticating: false
                    });
                    return true;
                }
                setState({
                    ...state,
                    authenticating: false
                });
            }
            catch (ex) {
                //debugger;
                setState({
                    ...state,
                    authenticating: false
                });
                console.log(ex)
            }
            return false;
        };

        const getInitials = (givenName?: string, surname?: string): string => {
            var initials = '';
            if (givenName && givenName.length > 0)
                initials += givenName[0].toUpperCase();
            if (surname && surname.length > 0)
                initials += surname[0].toUpperCase();
            return initials;
        }

        const setErrorMessage = (message: string, debug: string) => {
            setState({
                error: { message: message, debug: debug },
                ...state
            });
        }
        const getProfile = async () => {
            if (accounts && accounts.length > 0) {
                await populateUserProfile();
            }
            else {
                setState({
                    ...state,
                    authenticating: false
                });
            }
        }

        useEffect(() => {
            if (init)
                getProfile();
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [accounts]);
        return <Component login={login} logout={logout} error={state.error} user={state} getAccessToken={(scopes: string[]) => getAccessToken(scopes)} setError={(message: string, debug: string) => setErrorMessage(message, debug)} {...props as any} />;
    }
